import '~ui/setup/lang';
import '~ui/setup/constructor-styles';

import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {PageConstructorProvider} from '@gravity-ui/page-constructor';
import type {Metrika} from '@gravity-ui/page-constructor';

import {LANG} from '~ui/constants';

import {PromoPage} from '~ui/components/PromoPage';
import {WithRenderCallback} from '~ui/components/WithRenderCallback';

import {withAppProviders} from '~ui/hocs/with-app-providers';
import {crossMetrika, initCounter} from '~ui/services/metrika';
import {rumSendBeforeFrameworkInit, rumSendFrameworkInited} from '~ui/utils/rum';

if (window.__DATA__.crossMetrikaId) {
    initCounter('Cross', window.__DATA__.crossMetrikaId);
}

rumSendBeforeFrameworkInit();

const PromoApp: React.FC<{}> = () => (
    <PageConstructorProvider metrika={{metrika: crossMetrika as unknown as Metrika}}>
        <PromoPage lang={LANG} />
    </PageConstructorProvider>
);

const Component = withAppProviders(PromoApp);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
    <WithRenderCallback callback={rumSendFrameworkInited}>
        <StrictMode>
            <Component />
        </StrictMode>
    </WithRenderCallback>,
);
